import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AppService {

  public isWideScreen$ = new BehaviorSubject<boolean>(false);
  public displayStepper$ = new BehaviorSubject<boolean>(true);

  constructor() { }

}
